export default {
  BASE_URL: '',
  api: [
    {
      name: 'template',
      desc: '订单导入下载订单Excel模板',
      method: 'GET',
      path: '/tm/order/import/template'
    },
    {
      name: 'templateV2',
      desc: '订单导入下载订单Excel模板V2',
      method: 'GET',
      path: '/tm/order/import/templateV2'
    },
    {
      name: 'import',
      desc: '订单导入',
      method: 'GET',
      path: '/tm/order/import'
    },
    {
      name: 'importV2',
      desc: '订单导入V2',
      method: 'GET',
      path: '/tm/order/importV2'
    },
    {
      name: 'orderList',
      desc: '未推送,已推送的销售订单列表查询(只针对导入的订单)',
      method: 'GET',
      path: '/tm/order/orderList'
    },
    {
      name: 'pushToJinDie',
      desc: '导入订单推送（单个,批量）',
      method: 'POST',
      path: '/tm/order/pushToJinDie'
    },
    {
      name: 'getOrderPushLog',
      desc: '收付款单推送记录列表',
      method: 'GET',
      path: '/tm/order/getOrderPushLog'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/order/importOrder.js